export const streamingIntentLocalStorageKey = "pendingStreamingIntent";
